import useEmblaCarousel from 'embla-carousel-react';
import { Children, ReactNode } from 'react';

export function VideoGalleryCarousel({ children }: { children: ReactNode }) {
  const [emblaRef] = useEmblaCarousel({});

  return (
    <div className="overflow-hidden w-full" ref={emblaRef}>
      <div className={`${Children.count(children) < 4 ? "justify-start" : "justify-between"} flex touch-pan-y touch-pinch-zoom m-0`}>
        {Children.map(children, (child, i) => {
          const isLastElement = i === Children.count(children) - 1;
          const marginClassName = Children.count(children) < 4 ? "mr-20" : "mr-5";

          return (
            <div className={isLastElement ? "": marginClassName}>
              {child}
            </div>
          )
        })}
      </div>
    </div>
  )
}
